import {
  GET_DMX_COMPATIBLE_DEVICES,
  GET_DMX_COMPATIBLE_DEVICES_SUCCESS,
  GET_DMX_COMPATIBLE_DEVICES_ERROR,
} from './actionTypes';

export const getDmxCompatibleDevices = (user, deviceId) => {
  return {
    type: GET_DMX_COMPATIBLE_DEVICES,
    payload: { user, deviceId },
  };
};

export const getDmxCompatibleDevicesSuccess = (devices) => {
  return {
    type: GET_DMX_COMPATIBLE_DEVICES_SUCCESS,
    payload: { devices },
  };
};

export const getDmxCompatibleDevicesError = (error) => {
  return {
    type: GET_DMX_COMPATIBLE_DEVICES_ERROR,
    payload: error,
  };
};
